import { createApplicationService } from "./base/applicationServiceBase";
import { AccountsAPI } from "api/axios.config";
import { useCompany } from "./companyService";

//-------------------------------------------
//           API Functions
//-------------------------------------------

const VATS_BASE = "/VatCodes";

const fetchVatsAPI = () => AccountsAPI.get(`${VATS_BASE}`);

const addNewVatAPI = (data) =>
  AccountsAPI.post(VATS_BASE, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateVatAPI = (id, data) =>
  AccountsAPI.patch(`${VATS_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

//-------------------------------------------

const baseService = createApplicationService({
  name: "vats",
  apiFetchFn: fetchVatsAPI,
  apiAddFn: addNewVatAPI,
  apiUpdateFn: updateVatAPI,
});

const vatReducer = baseService.reducer;
const getVats = baseService.getData;
const addVat = baseService.addData;
const updateVat = baseService.updateData;
const useVats = baseService.useData;

const getActiveVats = async () => {
  const allVats = await getVats();
  return allVats?.filter((item) => item.includeInVatReturn) || [];
};

const useActiveVats = () => {
  const { data, loading } = useVats();
  const filteredData = data?.filter((item) => item.active) || [];
  return { loading, data: filteredData };
};

const useVatsWithDefault = () => {
  const { data: vatData, loading: vatLoading } = useVats();
  const { data: companyData, loading: companyLoading } = useCompany();
  
  const loading = vatLoading || companyLoading;
  
  const dataWithDefault = vatData?.map(vat => ({
    ...vat,
    isDefault: companyData?.defaultVatCodeId != null && 
               companyData.defaultVatCodeId !== undefined &&
               companyData.defaultVatCodeId === vat.vatCodeId
  })) || [];
  
  return { loading, data: dataWithDefault };
};

export {
  vatReducer,
  getVats,
  addVat,
  updateVat,
  useVats,
  useActiveVats,
  useVatsWithDefault,
  getActiveVats,
};
